import React, { useState } from 'react';
import { Breadcrumb, Row, Col, Menu, Popover, Spin, Select } from 'antd';
import Background1 from '../../../../static/img/bg-sdk-type1.png';
import Background2 from '../../../../static/img/bg-sdk-type2.png';
import Background3 from '../../../../static/img/bg-sdk-type3.png';
import Background4 from '../../../../static/img/bg-sdk-type4.png';
import { Column } from '@ant-design/plots';
import {
    queryApplicenseCount, queryCompaniesCount, queryDeviceCount, queryMeasureCount,
    queryApplicenseCountByDate, queryCompanyCountByDateStartDate2,
    queryDeviceTypeList, queryDeviceActiveTrendByMonths,
    queryMeasureTrendByMonths
} from "./gqls";
import Client from '../../../../lib/gqlClient';
import getWantTimestamp from '../../../../lib/utils/times'
import moment from 'moment-timezone';
import './index.css'
import { Link } from 'react-router-dom';
const CompanyList = () => {

    const [applicenseCount, setApplicenseCount] = useState(0)
    const [companiesCount, setCompaniesCount] = useState(0)
    const [deviceCount, setDeviceCount] = useState(0)
    const [measureCount, setMeasureCount] = useState(0)


    const [isSelectAppOrCompaniesLoading, setIsSelectAppOrCompaniesLoading] = useState(false)//是否正在加载
    let isSelectAppOrCompanies = true //true app  false  companies
    const [oneList, setOneList] = useState([])
    const [AppOrCompaniesName, setAppOrCompaniesName] = useState('新增授权App')
    const [appOrCompaniesNameItem, setAppOrCompaniesNameItem] = useState('授权App')


    const [isSelectDeviceOrMeasureLoading, setIsSelectDeviceOrMeasureLoading] = useState(false)//是否正在加载
    const [isSelectTypeListLoading, setIsSelectTypeListLoading] = useState(false)//是否正在加载
    let isSelectDeviceOrMeasure = true //true app  false  companies
    const [twoList, setTwoList] = useState([])
    const [selectTypeList, setSelectTypeList] = useState([])//当前展示list
    const [selectData, setSelectData] = useState("Select device type")//当前选择类型
    const [DeviceOrMeasureName, setDeviceOrMeasureName] = useState('总使用设备数趋势')
    const [deviceOrMeasureNameItem, setDeviceOrMeasureNameItem] = useState('总使用设备数趋势')

    const [time1, setTime1] = useState()
    const [timeList1, setTimeList1] = useState([{}])
    const [time2, setTime2] = useState()
    const [timeList2, setTimeList2] = useState([{}])
    React.useEffect(() => {
        //APP
        Client(queryApplicenseCount)
            .then((res) => {
                if (res !== null) {
                    setApplicenseCount(toThousands(res.data.getApplicenseCount))
                }
            }).catch(e => {
            })
        //公司
        Client(queryCompaniesCount)
            .then((res) => {
                if (res !== null) {
                    setCompaniesCount(toThousands(res.data.getCompaniesCount))
                }
            }).catch(e => {
            })
        //设备
        Client(queryDeviceCount)
            .then((res) => {
                if (res !== null) {
                    setDeviceCount(toThousands(res.data.getDeviceCount))
                }
            }).catch(e => {
            })
        //测量
        Client(queryMeasureCount)
            .then((res) => {
                console.log(res)
                if (res !== null) {
                    setMeasureCount(toThousands(res.data.getMeasureCount))
                }
            }).catch(e => {
                // console.log(e);
            })

        setIsSelectTypeListLoading(true)
        //设备类型
        Client(queryDeviceTypeList)
            .then((res) => {
                if (res !== null) {
                    let list = []
                    res.data.getDeviceTypeList.map((item, index) => {
                        list[index] = {
                            key: index + '',
                            label: (<a> {item} </a>)
                        }
                    })
                    setSelectTypeList(res.data.getDeviceTypeList)
                    setIsSelectTypeListLoading(false)
                }
            }).catch(e => {
                setIsSelectTypeListLoading(false)
            })


        let year = moment().utc().year();
        setTime1(year)
        setTime2(year)

        var list = [{}]
        list[0] = { value: '本季度', label: '本季度' }
        for (let index = 1; index <= year - 2020 + 1; index++) {
            list[index] = { value: year - index + 1, label: year - index + 1 }
        }
        list[year - 2020 + 2] = { value: '全部', label: '全部' }
        setTimeList1(list)
        setTimeList2(list)
        isGetSelectAppOrCompanies(year);
        isGetSelectDeviceOrMeasure(year);


    }, [])
    function onClick(e) {
        console.log(e)
        switch (e.key) {
            case "1":
                //刷新授权app
                isSelectAppOrCompanies = true
                isGetSelectAppOrCompanies(time1);
                break;
            case "2":
                //刷新授权公司
                isSelectAppOrCompanies = false
                isGetSelectAppOrCompanies(time1);
                break;


            case "3":
                //刷新总设备数
                isSelectDeviceOrMeasure = true
                setSelectData("Select device type")
                isGetSelectDeviceOrMeasure(time2);
                break;
            case "4":
                //刷新总测量数
                isSelectDeviceOrMeasure = false
                setSelectData("Select device type")
                isGetSelectDeviceOrMeasure(time2);
                break;
            default:
                break;
        }
    }
    //刷新 授权app/授权公司
    function isGetSelectAppOrCompanies(type) {
        var start = ''
        var end = ''
        let year = ''
        switch (type) {
            case '本季度':
                start = getWantTimestamp("threeMonthDayZero");
                end = getWantTimestamp("nowData");
                year = moment().utc().year();
                break;
            case '全部':
                start = moment.tz('2020-01-01T00:00:00', 'ETC/GMT+0').valueOf()
                end = getWantTimestamp("nowData")
                year = 2020
                break;
            default: {
                start = moment.tz(type + '-01-01T00:00:00', 'ETC/GMT+0').valueOf()
                end = moment.tz(type + '-12-31T23:59:59', 'ETC/GMT+0').valueOf()
                year = type
            }
        }

        setIsSelectAppOrCompaniesLoading(true)
        if (isSelectAppOrCompanies) {
            setAppOrCompaniesName('新增授权App')
            setAppOrCompaniesNameItem('授权App')
            getApplicenseCountByDate(type, start, end, year)
        } else {
            setAppOrCompaniesName('新增授权公司')
            setAppOrCompaniesNameItem('授权公司')
            getCompaniesCountByDate(type, start, end, year)
        }
    }
    function getApplicenseCountByDate(type, start, end, year) {
        //默认显示全年 1本月 2本季度 3全年
        isSelectAppOrCompanies = true
        // this.setState({ appSelectItem: type })
        Client(
            queryApplicenseCountByDate,
            {
                startDate: start,
                endDate: end
            }
        ).then((res) => {
            if (res !== null) {
                const list = res.data.getApplicenseCountByDate
                let data = [{}];
                list.map((item, index) => {
                    data[index] = {
                        type: item.year + "-" + item.month,
                        sales: item.count,
                    }
                })
                setOneList(data)
                setIsSelectAppOrCompaniesLoading(false)
            }
        }).catch(e => {
            setOneList()
            setIsSelectAppOrCompaniesLoading(false)
        })
    }
    function getCompaniesCountByDate(type, start, end, year) {
        //默认显示全年 1本月 2本季度 3全年
        isSelectAppOrCompanies = false
        // this.setState({ appSelectItem: type })
        Client(
            queryCompanyCountByDateStartDate2,
            {
                startDate: start,
                endDate: end
            }
        ).then((res) => {
            if (res !== null) {
                const list = res.data.getCompanyCountByDate
                let data = [{}];
                list.map((item, index) => {
                    data[index] = {
                        type: item.year + "-" + item.month,
                        sales: item.count,
                    }
                })
                setOneList(data)
                setIsSelectAppOrCompaniesLoading(false)
            }
        }).catch(e => {
            setOneList()
            setIsSelectAppOrCompaniesLoading(false)
        })
    }
    //刷新总设备 /总测量
    function isGetSelectDeviceOrMeasure(type, selectType) {

        console.log(type, selectType)
        var start = ''
        var end = ''
        let month = moment().utc().month() + 1;
        let year = moment().utc().year();
        switch (type) {
            case '本季度':
                let quarter = ''
                if (month >= 1 && month <= 3) {
                    quarter = '01'
                } else if (month >= 4 && month <= 6) {
                    quarter = '04'
                } else if (month >= 7 && month <= 9) {
                    quarter = '07'
                } else if (month >= 10 && month <= 12) {
                    quarter = '10'
                }
                start = year + "-" + quarter
                end = year + "-" + month
                break;
            case '全部':
                start = "2020-01"
                end = year + "-" + month
                break;
            default: {
                start = type + '-01'
                end = type + '-12'
            }
        }
        setIsSelectDeviceOrMeasureLoading(true)
        if (isSelectDeviceOrMeasure) {
            setDeviceOrMeasureName('总使用设备数趋势')
            setDeviceOrMeasureNameItem('总使用设备数')
            if ("Select device type" === selectType) {
                getDeviceCountByDate(type, start, end)
            } else {
                getDeviceCountByDate(type, start, end, selectType)
            }
        } else {
            setDeviceOrMeasureName('总测量数据数趋势')
            setDeviceOrMeasureNameItem('总测量数据数')
            if ("Select device type" === selectType) {
                getMeasureCountByDate(type, start, end,)
            } else {
                getMeasureCountByDate(type, start, end, selectType)
            }
        }
    }
    function getDeviceCountByDate(type, start, end, selectType) {

        console.log(type, start, end, selectType)
        //默认显示全年 1本月 2本季度 3全年
        isSelectDeviceOrMeasure = true
        // this.setState({ appSelectItem: type })
        Client(
            queryDeviceActiveTrendByMonths,
            {
                start: start,
                end: end,
                deviceModel: selectType
            }
        ).then((res) => {
            if (res !== null) {
                const list = res.data.deviceActiveTrendByMonths
                let data = [{}];
                list.map((item, index) => {
                    data[index] = {
                        type: item.year + "-" + item.month,
                        sales: item.count,
                    }
                })
                setTwoList(data)
                setIsSelectDeviceOrMeasureLoading(false)
            }
        }).catch(e => {
            setTwoList()
            setIsSelectDeviceOrMeasureLoading(false)
        })
    }
    function getMeasureCountByDate(type, start, end, selectType) {
        //默认显示全年 1本月 2本季度 3全年
        isSelectDeviceOrMeasure = false
        // this.setState({ appSelectItem: type })
        Client(
            queryMeasureTrendByMonths,
            {
                start: start,
                end: end,
                deviceModel: selectType
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                const list = res.data.measureTrendByMonths
                let data = [{}];
                list.map((item, index) => {
                    data[index] = {
                        type: item.year + "-" + item.month,
                        sales: item.count,
                    }
                })
                setTwoList(data)
                setIsSelectDeviceOrMeasureLoading(false)
            }
        }).catch(e => {
            setTwoList()
            setIsSelectDeviceOrMeasureLoading(false)
        })
    }
    //选择设备类型
    function handleChange(e) {
        setSelectData(e)
        if (DeviceOrMeasureName === '总使用设备数趋势') {
            isSelectDeviceOrMeasure = true
        } else {
            isSelectDeviceOrMeasure = false
        }
        console.log(e)
        isGetSelectDeviceOrMeasure(time2, e)
    }
    const onItemsMembersClick1 = (value) => {
        console.log(value)
        setTime1(value)
        isGetSelectAppOrCompanies(value);
    };
    const onItemsMembersClick2 = (value) => {
        console.log(value)
        setTime2(value)
        isGetSelectDeviceOrMeasure(value);
    };
    return (
        <div style={{ height: '100%', width: '100%', }}>


            {/* 标题头 */}
            <div style={{ height: '276px', padding: '0px', backgroundColor: 'white', borderRadius: '2px' }}>
                <Breadcrumb style={{ marginLeft: '20px', paddingTop: '6px' }}>
                    <Breadcrumb.Item><Link to='../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><a style={{ fontSize: '12px' }}>SDK Dashboard</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a style={{ fontSize: '12px' }}>数据统计</a></Breadcrumb.Item>
                </Breadcrumb>

                <Row style={{ marginTop: '30px', marginLeft: '6px', marginRight: '6px', }}>
                    <Col span={6}>
                        <div style={{ height: '188px', padding: '0px', marginRight: '20px', backgroundImage: `url(${Background1})`, backgroundSize: 'cover', }}>
                            <Row style={{ height: '44px' }}>
                                <Col span={22}>
                                    <span style={Styles.cardTitle}> SDK授权App总数</span>
                                </Col>
                                <Col span={2} >
                                    <Popover placement="bottomRight" content={contentApp}>
                                        <img src={require('../../../../static/img/ic-info-circle-anticon.png')} style={{ marginTop: '10px', width: '14px', height: '14px' }} />
                                    </Popover>
                                </Col>
                            </Row>
                            <Row style={Styles.cardData}>
                                <Col><a style={Styles.cardCount}>
                                    {applicenseCount}</a></Col>
                                <Col>
                                    <a style={Styles.cardCompany}>
                                        个</a>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div style={{ height: '188px', padding: '0px', marginRight: '20px', backgroundImage: `url(${Background2})`, backgroundSize: 'cover', }}>
                            <Row style={{ height: '44px' }}>
                                <Col span={22}>
                                    <span style={Styles.cardTitle}> SDK授权公司总数</span>
                                </Col>
                                <Col span={2} >
                                    <Popover placement="bottomRight" content={contentCompanies}>
                                        <img src={require('../../../../static/img/ic-info-circle-anticon.png')} style={{ marginTop: '10px', width: '14px', height: '14px' }} />
                                    </Popover>
                                </Col>
                            </Row>
                            <Row style={Styles.cardData}>
                                <Col><a style={Styles.cardCount}>
                                    {companiesCount}</a></Col>
                                <Col>
                                    <a style={Styles.cardCompany}>
                                        家</a>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div style={{ height: '188px', padding: '0px', marginRight: '20px', backgroundImage: `url(${Background3})`, backgroundSize: 'cover', }}>

                            <Row style={{ height: '44px' }}>
                                <Col span={22}>
                                    <span style={Styles.cardTitle}> 总使用设备数</span>
                                </Col>
                                <Col span={2} >
                                    <Popover placement="bottomRight" content={contentDevice}>
                                        <img src={require('../../../../static/img/ic-info-circle-anticon.png')} style={{ marginTop: '10px', width: '14px', height: '14px' }} />
                                    </Popover>
                                </Col>
                            </Row>
                            <Row style={Styles.cardData}>
                                <Col><a style={Styles.cardCount}>
                                    {deviceCount}</a></Col>
                                <Col>
                                    <a style={Styles.cardCompany}>
                                        台</a>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div style={{ height: '188px', padding: '0px', backgroundImage: `url(${Background4})`, backgroundSize: 'cover', }}>

                            <Row style={{ height: '44px' }}>
                                <Col span={22}>
                                    <span style={Styles.cardTitle}> 总测量数据</span>
                                </Col>
                                <Col span={2} >
                                    <Popover placement="bottomRight" content={contentMeasure}>
                                        <img src={require('../../../../static/img/ic-info-circle-anticon.png')} style={{ marginTop: '10px', width: '14px', height: '14px' }} />
                                    </Popover>
                                </Col>
                            </Row>
                            <Row style={Styles.cardData}>
                                <Col><a style={Styles.cardCount}>
                                    {measureCount}</a></Col>
                                <Col>
                                    <a style={Styles.cardCompany}>
                                        条</a>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </div>


            {/* 授权App,公司  柱状图 */}
            <div style={{ height: '404px', padding: '0px', marginTop: '15px', backgroundColor: 'white', borderRadius: '2px' }}>

                <div style={{ height: '55px', padding: '0px', }}>
                    <Row>
                        <Col span={12}>
                            <Menu defaultSelectedKeys={['1']}
                                defaultOpenKeys={['a']}
                                mode="horizontal"
                                style={{ justifyContent: 'start' }}
                                items={itemsOne}
                                onClick={onClick}
                            >
                            </Menu>
                        </Col>
                        <Col span={12} style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
                            {/* <Button className="btn" onClick={() => btnAppOrCompanies(2)} type="text" style={{ color: (appOrCompaniesSelectItem === 2 ? '#2657F9' : '#000'), border: 'none' }}>本季度</Button>
                            <Button className="btn" onClick={() => btnAppOrCompanies(3)} type="text" style={{ border: 'none', color: (appOrCompaniesSelectItem === 3 ? '#2657F9' : '#000'), marginRight: '18px' }}>本年</Button> */}
                            <div style={{
                                marginRight: '18px', width: '200px', minHeight: '30px', borderRadius: "2px", border: '1px solid rgba(0, 0, 0, 0.2)'
                            }}>
                                <Select
                                    className='select'
                                    size='middle'
                                    style={{
                                        width: '200px',
                                    }}
                                    maxTagCount='responsive'
                                    showArrow={true}
                                    bordered={false}
                                    placeholder="Please select"
                                    onSelect={onItemsMembersClick1}
                                    options={timeList1}
                                    value={time1}
                                />
                            </div>
                        </Col>
                    </Row>
                    <div style={{ height: '1px', backgroundColor: '#E8E8E8' }} />
                </div>
                <a style={{ marginLeft: '56px', marginTop: '24px', display: 'block', fontSize: '16px', lineHeight: '24px', color: ' #2657F9' }}>{AppOrCompaniesName}</a>
                <Spin size="large" tip="Loading..." spinning={isSelectAppOrCompaniesLoading}>
                    <Column {...{
                        data: oneList,
                        xField: 'type',
                        yField: 'sales',
                        color: '#2657F9',
                        columnWidthRatio: 0.4,
                        marginRatio: 0.6,
                        legend: false,
                        minColumnWidth: 30,
                        xAxis: {
                            label: {
                                autoHide: true,
                                autoRotate: false,
                            },
                        },
                        meta: {
                            sales: {
                                alias: appOrCompaniesNameItem,
                            },
                        },
                        scrollbar: {
                            type: 'horizontal',
                        },
                    }} style={{ height: '246px', marginTop: '20px', marginBottom: '33px', marginLeft: '99px', marginRight: '94px' }} />
                </Spin>

            </div>
            {/* 总使用设备数,总测量数据  柱状图 */}
            <div style={{ height: '404px', padding: '0px', marginTop: '15px', backgroundColor: 'white', borderRadius: '2px' }}>
                <div style={{ height: '55px', padding: '0px', }}>
                    <Row>
                        <Col span={12}>
                            <Menu defaultSelectedKeys={['3']}
                                defaultOpenKeys={['a']}
                                mode="horizontal"
                                style={{ justifyContent: 'start' }}
                                items={itemsTwo}
                                onClick={onClick}>
                            </Menu>
                        </Col>
                        <Col span={12} style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
                            <Spin size="large" tip="Loading..." spinning={isSelectTypeListLoading}>
                                <div style={{
                                    marginRight: '18px', width: '200px', minHeight: '30px', borderRadius: "2px", border: '1px solid rgba(0, 0, 0, 0.2)'
                                }}>
                                    <Select
                                        className='select'
                                        size='middle'
                                        style={{
                                            width: '200px',
                                        }}
                                        maxTagCount='responsive'
                                        showArrow={true}
                                        bordered={false}
                                        placeholder="Please select"
                                        onChange={(e) => {
                                            // console.log(e);
                                            handleChange(e)
                                        }}
                                        value={selectData}
                                    >{selectTypeList.map(it => (
                                        <Select.Option value={it}>
                                            {it}
                                        </Select.Option>
                                    ))}</Select>
                                </div>
                            </Spin>
                            {/* <Button className="btn" onClick={() => btnDeviceOrMeasure(2)} type="text" style={{ color: (deviceOrMeasureSelectItem === 2 ? '#2657F9' : '#000'), border: 'none' }}>本季度</Button>
                            <Button className="btn" onClick={() => btnDeviceOrMeasure(3)} type="text" style={{ color: (deviceOrMeasureSelectItem === 3 ? '#2657F9' : '#000'), border: 'none', marginRight: '18px' }}>本年</Button> */}
                            <div style={{
                                marginRight: '18px', width: '200px', minHeight: '30px', borderRadius: "2px", border: '1px solid rgba(0, 0, 0, 0.2)'
                            }}>
                                <Select
                                    className='select'
                                    size='middle'
                                    style={{
                                        width: '200px',
                                    }}
                                    maxTagCount='responsive'
                                    showArrow={true}
                                    bordered={false}
                                    placeholder="Please select"
                                    onSelect={onItemsMembersClick2}
                                    options={timeList2}
                                    value={time2}
                                />
                            </div>
                        </Col>
                    </Row>
                    <div style={{ height: '1px', backgroundColor: '#E8E8E8' }} />
                </div>
                <a style={{ marginLeft: '56px', marginTop: '24px', display: 'block', fontSize: '16px', lineHeight: '24px', color: ' #2657F9' }}>{DeviceOrMeasureName}</a>
                <Spin size="large" tip="Loading..." spinning={isSelectDeviceOrMeasureLoading}>
                    <Column {...{
                        data: twoList,
                        xField: 'type',
                        yField: 'sales',
                        color: '#2657F9',
                        columnWidthRatio: 0.4,
                        marginRatio: 0.6,
                        legend: false,
                        minColumnWidth: 30,
                        xAxis: {
                            label: {
                                autoHide: true,
                                autoRotate: false,
                            },
                        },
                        meta: {
                            sales: {
                                alias: deviceOrMeasureNameItem,
                            },
                        },
                        scrollbar: {
                            type: 'horizontal',
                        },
                    }} style={{ height: '246px', marginTop: '20px', marginBottom: '33px', marginLeft: '99px', marginRight: '94px' }} />
                </Spin>
            </div>

        </div>
    );
    function toThousands(num) {
        var num = (num || 0).toString(), re = /\d{3}$/, result = '';
        while (re.test(num)) {
            result = RegExp.lastMatch + result;
            if (num !== RegExp.lastMatch) {
                result = ',' + result;
                num = RegExp.leftContext;
            }
            else {
                num = '';
                break;
            }
        }
        if (num) { result = num + result; }
        return result;
    }


}
const contentApp = (
    <div style={{ width: '235px' }}>
        <div style={{ fontSzie: '14px', }}>统计内容：North America, South America地区所有获得永久授权的App数量总和。 </div>
        <div style={{ fontSzie: '14px', marginTop: '22px' }}>统计时间：2018-03-至今</div>
    </div>
);
const contentCompanies = (
    <div style={{ width: '235px' }}>
        <div style={{ fontSzie: '14px', }}>统计内容：North America, South America地区所有获得永久授权的公司数量总和。</div>
        <div style={{ fontSzie: '14px', marginTop: '22px' }}>统计时间：2018-03-至今</div>
    </div>
);
const contentDevice = (
    <div style={{ width: '235px' }}>
        <div style={{ fontSzie: '14px', }}>统计内容：North America, South America地区所有使用过的设备数量总和。 </div>
        <div style={{ fontSzie: '14px', marginTop: '22px' }}>统计时间：2018-03-至今</div>
    </div>
);
const contentMeasure = (
    <div style={{ width: '235px' }}>
        <div style={{ fontSzie: '14px', }}>统计内容：North America, South America地区所有测量过的数据条数总和。 </div>
        <div style={{ fontSzie: '14px', marginTop: '22px' }}>统计时间：2018-03-至今</div>
    </div>
);
const Styles = {
    title: {
        display: 'block',
        fontSize: '20px',
        color: '#000000',
        marginLeft: '150px',
        marginTop: '25px'
    },
    cardTitle: {
        fontSize: '20px',
        color: '#767676',
        display: 'block',
        lineHeight: '22px',
        paddingTop: '20px',
        marginLeft: '24px',

    },
    cardData: {
        marginTop: '42px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'

    },
    cardCount: {
        fontSize: '50px',
        fontWeight: 'normal',
        color: '#000000',
        display: 'block',
        lineHeight: '38px',
    },
    cardCompany: {
        marginTop: '16px',
        fontSize: '20px',
        fontWeight: 'normal',
        color: '#000000',
        display: 'block',
        lineHeight: '22px',
    }

}
function getItem(label, key,) {
    return {
        key,
        label,
    };
}
const itemsOne = [
    getItem('授权App', '1'),
    getItem('授权公司', '2'),

];
const itemsTwo = [
    getItem('总使用设备数', '3'),
    getItem('总测量数据', '4'),

];
export default CompanyList